// extracted by mini-css-extract-plugin
export default {"loading_spinner":"CircularLoader_loading_spinner__z8haN","spin":"CircularLoader_spin__s9PK+"};